export const initialValues = {
  title: '',
  providers: [],
  text: '',
};

export default initialValues;
